// extracted by mini-css-extract-plugin
export default {"accent":"login-page_accent__S2m02","loginPage":"login-page_loginPage__7XlwD"};